import beforeApi from './modules/beforeApi.js'
const apiFetch = Object.assign({}, beforeApi)
export default apiFetch
